import { getRequiredOnboarding } from 'pricing-pages-lib/api/RequiredOnboardingApi';
import { REQUIRED_ONBOARDING } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
export const FetchRequiredOnboardingRequestTypes = createRequestTypes(REQUIRED_ONBOARDING);
export const FetchRequiredOnboardingActions = createRequestActions(FetchRequiredOnboardingRequestTypes);
export const fetchRequiredOnboarding = () => makeFetchRequest({
  requestActions: FetchRequiredOnboardingActions,
  fetch: getRequiredOnboarding
});